import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import {
  IAdminClubInvitationRequest,
  IAdminEventInvitationRequest,
  IAdminInvitationsStore
} from './store';

export interface IAdminInvitationsActions extends IActionGroup {
  create: (
    data: IAdminClubInvitationRequest | IAdminEventInvitationRequest
  ) => { invitations?: IAdminInvitationsStore; errors?: IErrorsStore };
  getByEvent: (eventId: number) => { invitations?: IAdminInvitationsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (
    state: IStore,
    data: IAdminClubInvitationRequest | IAdminEventInvitationRequest
  ) => {
    const response = await request.post(`${api.admin.invitations}`, data);

    if (response.error) {
      return { errors: { invitations: { msg: 'Error inviting guests to the event.' } } };
    }

    const clubId = data.club;

    let invitations;
    if (!(data as IAdminEventInvitationRequest).event) {
      const memberships = (state.adminInvitations.clubMemberships[clubId] || []).concat(
        response.valid
      );
      invitations = {
        clubMemberships: {
          ...state.adminInvitations.clubMemberships,
          [clubId]: memberships
        }
      };
    } else {
      const eventId = (data as IAdminEventInvitationRequest).event;
      const memberships = (state.adminInvitations.eventMemberships[eventId] || []).concat(
        response.valid
      );
      invitations = {
        eventMemberships: {
          ...state.adminInvitations.eventMemberships,
          [eventId]: memberships
        }
      };
    }

    return {
      adminInvitations: invitations
    };
  },
  getByEvent: async (state: IStore, eventId: number) => {
    if (state.adminInvitations.eventMemberships[eventId]) {
      return state;
    }

    const response = await request.get(api.admin.eventInvitations(eventId));
    if (response.error) {
      return {
        errors: { eventInvitations: { msg: 'Error retrieving the Event Invitation List.' } }
      };
    }

    return {
      adminInvitations: {
        eventMemberships: {
          ...state.adminInvitations.eventMemberships,
          [eventId]: response
        }
      }
    };
  }
};

export default actions;
